module.exports = __webpack_public_path__ + "media/images/flags/MH-2149680b030049a700a7856917d5f2fe.svg";